// Phosphor icons for markup built in JS. Outputs the same <svg> as IconHelper#icon
// (app/helpers/icon_helper.rb) so JS-added rows match server-rendered ones.
// Paths are the bold weight from app/models/phosphor_icon/catalog.rb.
const PATHS = {
  x: '<path d="M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"/>',
  'x-circle':
    '<path d="M168.49,104.49,145,128l23.52,23.51a12,12,0,0,1-17,17L128,145l-23.51,23.52a12,12,0,0,1-17-17L111,128,87.51,104.49a12,12,0,0,1,17-17L128,111l23.51-23.52a12,12,0,0,1,17,17ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z"/>',
};

export const icon = (name, className = '') => {
  if (!PATHS[name]) throw new Error(`Unknown icon: ${name}`);
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" width="1.25em" height="1.25em" style="vertical-align: -0.25em"${className && ` class="${className}"`} aria-hidden="true">${PATHS[name]}</svg>`;
};
